import { t } from 'i18next';
import { PreferencesScreen } from '../pages/DashboardCustomer/Preferences';
import { CompanyDetailsScreen } from '../pages/DashboardManagement';
import { DashboardHomeOffice } from '../pages/DashboardOffice/DashboardHomeOffice';
import { RequestAgent } from '../pages/DashboardManagement/RequestAgent';
import { CompanyTransferScreen } from '../pages/DashboardManagement/CompanyTransfer';
import { EnvironmentSetupScreen } from '../pages/DashboardOffice/EnvironmentSetup';
import { DashBoardDocumentStatus } from '../pages/DashboardOffice/DashBoardDocumentStatus';
import { DashboardPaymentStatus } from '../pages/DashboardOffice/DashboardPaymentStatus/index';
import { DashboardApprovalDocument } from '../pages/DashboardOffice/DashboardApprovalDocument/index';
import { ComingSoonScreen } from '../pages/ComingSoon/ComingSoonScreen';

const agentRoutes = [
  {
    path: 'approval-document/:slug',
    name: 'Approval Document',
    component: <DashboardApprovalDocument />
  },
  {
    path: '',
    name: t('others.otheNewCompany'),
    component: <DashboardHomeOffice />
  },
  {
    path: 'transferred-companies',
    name: t('others.otheTransferredCompanies'),
    component: <CompanyTransferScreen />
  },
  {
    path: 'documents-status/:slug',
    name: 'Document Status',
    component: <DashBoardDocumentStatus />
  },
  {
    path: 'companies/:slug',
    name: t('labels.lblCompanyDetails'),
    component: <CompanyDetailsScreen />
  },
  {
    path: 'specialists',
    name: t('others.othScheduleSpecialist'),
    component: <ComingSoonScreen titleKey="others.othScheduleSpecialist" />
  },
  {
    path: 'request',
    name: t('labels.lblRequestsBar'),
    component: <RequestAgent />
  },
  {
    path: 'preferences',
    name: t('labels.lblPrefereces'),
    component: <PreferencesScreen />
  },
  {
    path: 'environment-setup',
    name: t('labels.lblEnvironmentSetup'),
    component: <EnvironmentSetupScreen />
  },
  {
    path: 'payment-status',
    name: t('labels.lblEnvironmentSetup'),
    component: <DashboardPaymentStatus />
  }
];

export { agentRoutes };
